import { BusinessResponses } from '@luxuryescapes/contract-business'
import request from 'api/requestUtils'

function registerBusiness(businessData: App.BusinessTraveller.BusinessSignupFormData): Promise<BusinessResponses.BusinessCreate> {
  const postData: App.BusinessTraveller.BusinessSignupData = {
    ...businessData,
    businessDetails: {
      businessIdentifier: businessData.businessDetails.businessIdentifier,
      businessIdentifierType: businessData.businessDetails.businessIdentifierType,
      country: businessData.businessDetails.country,
      employeeCount: businessData.businessDetails.numberOfEmployees,
      industry: businessData.businessDetails.industry,
      name: businessData.businessDetails.name,
      phone: `${businessData.businessDetails.phone.prefix} ${businessData.businessDetails.phone.phone}`,
      referralCode: businessData.businessDetails.referralCode,
      referralEmail: businessData.businessDetails.referralEmail,
    },
  }

  return request.post(
    '/api/business-traveller/businesses',
    postData,
    { credentials: 'include' },
  )
}

export default registerBusiness
